import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { BLOCK_GUIDANCE_SCREEN_SHOWN, CONTACT_SUPPORT_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { FROM } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { FRAUD_SOFT_BLOCK } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { FRAUD_BLOCK_INFO_MODAL } from 'apps/auth/constants/ComponentNames';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const FraudBlockDisclaimer = (props) => {
    const { fraudBlockDisclaimerText, fraudBlockDisclaimerText2, morePopupChatTitle } = usePageMessages();

    useEffect(() => {
        amplitude.getInstance().logEvent(BLOCK_GUIDANCE_SCREEN_SHOWN, {
            [FROM]: FRAUD_SOFT_BLOCK,
        });
    }, []);

    const getText = () => {
        return (props.error.errorCode === 616 || props.error.errorCode === 642) && !props.isUsaUser ? fraudBlockDisclaimerText2 : fraudBlockDisclaimerText;
    };

    return (
        <ModalComponent
            hasBottomPanel
            modalRef={props.modalRef}
            onCloseIconClick={() => {
                props.setModal(FRAUD_BLOCK_INFO_MODAL);
            }}
        >
            <article className="maincopy break_words first" id="disclaimer" dangerouslySetInnerHTML={{ __html: getText() }} />
            <FixedBottomPanel isRightAligned>
                <Button
                    type="button"
                    raised={true}
                    caption={morePopupChatTitle}
                    onClick={() => {
                        amplitude.getInstance().logEvent(CONTACT_SUPPORT_CLICKED);
                        props.toggleChat(true);
                    }}
                />
            </FixedBottomPanel>
        </ModalComponent>
    );
};

export default connect(null, { toggleChat })(FraudBlockDisclaimer);
